import env from "../../server.config";
import { RouteRecordRaw } from "vue-router";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/Login.vue"),
  },
  // {
  //   path: '/',
  //   name: 'login2',
  //   component: () => import('../views/login/Login.vue'),
  // },
  {
    path: "/login/:alert",
    name: "login.alert",
    component: () => import("../views/login/Login.vue"),
    props: true,
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/home/Home.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/documents",
    name: "documents",
    component: () => import("../views/documents/Documents.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/calc/:customerId/:calcId",
    name: "calc",
    component: () => import("../views/calc/Calc.vue"),
    props: true,
    meta: {
      requiresAuth: true,
      requiresIntegrator: true,
    },
  },
  {
    path: "/calcsessions/:customerId",
    name: "calcsessions",
    component: () => import("../views/calc-sessions/CalcSessions.vue"),
    props: true,
    meta: {
      requiresAuth: true,
      requiresIntegrator: true,
    },
  },
  {
    // This path is used to launch the project list page with the edit dialog pre-selected for :projectId
    path: "/projects/:customerId/:projectId",
    name: "projects.project",
    component: () => import("../views/projects/Projects.vue"),
    props: true,
    meta: {
      requiresAuth: true,
      requiresIntegrator: true,
    },
  },
  {
    path: "/projects/:customerId*",
    name: "projects",
    component: () => import("../views/projects/Projects.vue"),
    props: true,
    meta: {
      requiresAuth: true,
      requiresIntegrator: true,
    },
  },
  {
    path: "/details/:customerId/:projectId*",
    name: "details.project",
    component: () => import("../views/details/ProjectDetails.vue"),
    props: true,
    meta: {
      requiresAuth: true,
      requiresIntegrator: true,
    },
  },
  {
    path: "/register/int/:customerId",
    name: "register.int",
    component: () => import("../views/register/Register.vue"),
    props: true,
    meta: {
      requiresAuth: true,
      requiresIntegrator: true,
    },
  },
  {
    path: "/register/ext/:sernum",
    name: "register.ext",
    component: () => import("../views/register/Register.vue"),
    props: true,
    meta: {
      requiresAuth: true,
      requiresIntegrator: false,
    },
  },
  {
    path: "/support/tickets/:customerId",
    name: "support.tickets",
    component: () => import("../views/support-tickets/SupportTickets.vue"),
    meta: {
      requiresAuth: true,
      requiresIntegrator: true,
    },
  },
  {
    path: "/support/tickets/new/:customerId",
    name: "support.tickets.new",
    props: true,
    component: () => import("../views/create-new-ticket/CreateNewTicket.vue"),
    meta: {
      requiresAuth: true,
      requiresIntegrator: true,
    },
  },
  {
    path: "/qxapi",
    name: "qx.api",
    component: () => import("../views/qxapi/qxapiInfo.vue"),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/opsportal",
    name: "ops.portal",
    beforeEnter(to, from, next) {
      window.location.href = env.apiBaseUrl + "/OpsPortal/#/home";
      next();
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/comingsoon/:id",
    name: "comingsoon",
    component: () => import("../views/ComingSoon.vue"),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "fallback",
    component: () => import("../views/home/Home.vue"),
    meta: {
      requiresAuth: true,
    },
  },
] as RouteRecordRaw[];
